import { StandardQuizQuestion } from '@/types/quizTypes';

export const RPA_ENTERPRISE_ARCHITECTURE_QUIZ: StandardQuizQuestion[] = [
  {
    id: "rpa-ent-1",
    question: "What is RPA (Robotic Process Automation)?",
    options: [
      "Physical robots in factories",
      "Software bots automating repetitive business processes",
      "AI chatbots",
      "Database automation"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "RPA uses software bots to automate repetitive, rule-based business processes by mimicking human interactions with digital systems, like data entry or report generation.",
    category: "rpa-basics",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-2",
    question: "What are the main components of enterprise RPA architecture?",
    options: [
      "Only bot software",
      "Bot development platform, orchestrator, bot runners, and control room",
      "Just cloud storage",
      "Only user interfaces"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Enterprise RPA includes: development tools for building bots, orchestrator for managing workflows, bot runners (attended/unattended), and control room for monitoring and governance.",
    category: "architecture",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-3",
    question: "What is the difference between attended and unattended bots?",
    options: [
      "No difference",
      "Attended bots work with human users, unattended run autonomously",
      "Attended are faster",
      "Unattended are cheaper"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Attended bots assist human workers on their workstations, triggered manually. Unattended bots run independently on servers, scheduled or triggered by events without human intervention.",
    category: "bot-types",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-4",
    question: "What is an RPA orchestrator?",
    options: [
      "A music player",
      "Central platform managing, scheduling, and monitoring bots",
      "A database",
      "A user interface"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The orchestrator is the central control hub that schedules bot execution, manages queues, monitors performance, handles errors, and provides governance for the RPA environment.",
    category: "orchestration",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-5",
    question: "What is a process queue in RPA?",
    options: [
      "Line of people waiting",
      "Managed list of work items for bots to process",
      "Database table",
      "Network buffer"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Process queues store work items (like invoices to process) in a managed, prioritized list. Bots pull items from queues, process them, and update status, enabling load balancing and retry logic.",
    category: "queue-management",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-6",
    question: "What is the REFramework in RPA?",
    options: [
      "A programming language",
      "Robotic Enterprise Framework - template for robust automation",
      "A database system",
      "A cloud service"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "REFramework is UiPath's template providing structure for enterprise automation with built-in error handling, logging, retry mechanisms, and transaction processing patterns.",
    category: "frameworks",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-7",
    question: "What is bot governance in enterprise RPA?",
    options: [
      "Bot permissions only",
      "Policies and controls for bot development, deployment, and monitoring",
      "Bot speed limits",
      "User authentication"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Bot governance encompasses policies, standards, and controls for bot lifecycle management including development standards, approval workflows, access control, audit trails, and compliance.",
    category: "governance",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "rpa-ent-8",
    question: "What is Cognitive RPA?",
    options: [
      "Regular RPA",
      "RPA combined with AI/ML for handling unstructured data",
      "Only rule-based automation",
      "Physical robot automation"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Cognitive RPA integrates AI capabilities like OCR, NLP, and ML with traditional RPA, enabling bots to handle unstructured data, make decisions, and learn from patterns.",
    category: "cognitive-automation",
    points: 15,
    type: "multiple-choice"
  }
];

export const generateRpaEnterpriseArchitectureQuiz = () => ({
  questions: RPA_ENTERPRISE_ARCHITECTURE_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'rpa-architecture'
});
